import { environment } from '../../src/environments/environment';
import { NgModule, ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

/* tslint:disable:no-var-requires */
declare var require: any
const Sentry: any = require("@sentry/browser");
/* tslint:enable:no-var-requires */

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {
    if (environment.SENTRY_ENABLED) {
      Sentry.init({
        dsn: 'https://ebde6d2e27cf4b9aafb8ca0f04d01c34@o374020.ingest.sentry.io/5456341',
        environment: environment.SENTRY_ENVIRONMENT_TYPE
      });
    }
  }

  extractError(error: any) {
    if (error && error.ngOriginalError) {
      error = error.ngOriginalError;
    }

    if (typeof error === 'string' || error instanceof Error) {
      return error;
    }

    if (error instanceof HttpErrorResponse) {
      if (error.error instanceof Error) {
        return error.error;
      }

      if (error.error instanceof ErrorEvent) {
        return error.error.message;
      }

      if (typeof error.error === 'string') {
        return `Server returned code ${error.status} with body "${error.error}"`;
      }

      return error.message;
    }

    return null;
  }

  handleError(error: Error) {
    const extractedError = this.extractError(error) || 'Handled unknown error';
    Sentry.captureException(extractedError);
  }
}



// WEBPACK FOOTER //
// ./src/app/sentry-error-handler.ts